import React from 'react';
import { mockData } from '../mock';

const About = () => {
  const { about } = mockData;

  return (
    <section id="sobre" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <div className="space-y-6">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight">
              {about.title}
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full" />
            <p className="text-lg text-gray-600 leading-relaxed">
              {about.description}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Nosso propósito é simplificar a operação fiscal das empresas, oferecendo ferramentas modernas, seguras e de alta performance.
            </p>
          </div>

          {/* Right Column - Stats */}
          <div className="grid grid-cols-2 gap-6">
            {about.highlights.map((highlight, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-2xl border border-gray-200 hover:border-purple-300 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                <div className="space-y-3">
                  <p className="text-5xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
                    {highlight.value}
                  </p>
                  <p className="text-sm font-medium text-gray-700 leading-snug">
                    {highlight.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Experience Section */}
        <div className="mt-20 bg-gradient-to-br from-purple-50 via-blue-50 to-cyan-50 rounded-3xl p-8 sm:p-12">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
            Experiência e Credibilidade
          </h3>
          <p className="text-lg text-gray-600 leading-relaxed mb-4">
            A EEDOC herda a expertise de décadas de trabalho com:
          </p>
          <ul className="space-y-3">
            <li className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-purple-600 rounded-full mt-2 flex-shrink-0" />
              <span className="text-gray-700">Sistemas corporativos de grande porte</span>
            </li>
            <li className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" />
              <span className="text-gray-700">Integrações fiscais municipais, estaduais e federais</span>
            </li>
            <li className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-cyan-600 rounded-full mt-2 flex-shrink-0" />
              <span className="text-gray-700">Soluções em automação e gestão empresarial</span>
            </li>
            <li className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-purple-600 rounded-full mt-2 flex-shrink-0" />
              <span className="text-gray-700">Suporte técnico reconhecido pela profundidade e agilidade</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
